var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.asText)?_c('div',{on:{"click":_vm.proxyUser}},[_vm._v("Proxy user")]):_c('b-button',{attrs:{"size":"sm","variant":"white"},on:{"click":_vm.proxyUser}},[_vm._v("Proxy user")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }